module.exports = __webpack_public_path__ + "img/KM211.217.3bce6cbb.png";